import React from "react"
import { Link } from "gatsby"
import { SEM_VIGNETTE } from "../utils/ads"

// Catálogo único de herramientas del sitio. Antes cada juego era un callejón sin
// salida: el baralho cigano y el jogo de tarot, que juntos son el 75% del tráfico,
// no enlazaban a ningún otro juego. Esto los conecta entre sí.
export const JOGOS = [
  { url: "/oraculo/baralho-cigano/", nome: "Baralho Cigano", desc: "Tire 3 cartas e veja o que dizem", icone: "🂡" },
  { url: "/jogo-de-tarot/", nome: "Jogo de Tarot", desc: "Passado, presente e futuro", icone: "🔮" },
  { url: "/oraculo/tarot-sim-ou-nao/", nome: "Tarot Sim ou Não", desc: "Uma pergunta, uma resposta", icone: "⚖️" },
  { url: "/oraculo/mesa-real/", nome: "Mesa Real", desc: "As 36 cartas abertas de uma vez", icone: "🗺️" },
  { url: "/oraculo/tarot-do-amor/", nome: "Tarot do Amor", desc: "As cartas do seu coração", icone: "💗" },
  { url: "/oraculo/tarot-da-sorte/", nome: "Tarot da Sorte", desc: "O que a sorte reserva", icone: "🍀" },
  { url: "/oraculo/runas/", nome: "Runas", desc: "A sabedoria dos povos do norte", icone: "ᚠ" },
  { url: "/oraculo/cristais/", nome: "Cristais", desc: "A energia das pedras", icone: "💎" },
  { url: "/mapa-astral/", nome: "Mapa Astral", desc: "Seu mapa completo, grátis", icone: "🪐" },
  { url: "/ascendente/", nome: "Ascendente", desc: "Como o mundo te vê", icone: "🌅" },
  { url: "/signo-chines/", nome: "Signo Chinês", desc: "Descubra o seu animal", icone: "🐉" },
  { url: "/astrologia/compatibilidade-amorosa/", nome: "Compatibilidade", desc: "Você e o seu par", icone: "💞" },
  { url: "/anjo-da-guarda/", nome: "Anjo da Guarda", desc: "Pela data de nascimento", icone: "👼" },
  { url: "/numerologia/", nome: "Numerologia", desc: "Os números do seu nome", icone: "🔢" },
  { url: "/carta-do-dia/", nome: "Carta do Dia", desc: "A mensagem de hoje", icone: "🌙" },
  { url: "/horoscopo/", nome: "Horóscopo do dia", desc: "Os 12 signos, todo dia", icone: "✨" },
]

// Qué ofrecer primero en cada página: lo más cercano a lo que la persona acaba
// de hacer. El resto se completa con los más populares del sitio.
const RELACIONADOS = {
  "/oraculo/baralho-cigano/": ["/oraculo/mesa-real/", "/carta-do-dia/", "/jogo-de-tarot/", "/oraculo/tarot-sim-ou-nao/"],
  "/oraculo/mesa-real/": ["/oraculo/baralho-cigano/", "/carta-do-dia/", "/jogo-de-tarot/", "/oraculo/runas/"],
  "/jogo-de-tarot/": ["/oraculo/tarot-sim-ou-nao/", "/oraculo/tarot-do-amor/", "/oraculo/baralho-cigano/", "/oraculo/tarot-da-sorte/"],
  "/oraculo/tarot-sim-ou-nao/": ["/jogo-de-tarot/", "/oraculo/baralho-cigano/", "/oraculo/tarot-do-amor/", "/oraculo/runas/"],
  "/oraculo/tarot-do-amor/": ["/astrologia/compatibilidade-amorosa/", "/jogo-de-tarot/", "/oraculo/tarot-sim-ou-nao/", "/oraculo/baralho-cigano/"],
  "/oraculo/tarot-da-sorte/": ["/oraculo/baralho-cigano/", "/jogo-de-tarot/", "/oraculo/tarot-sim-ou-nao/", "/numerologia/"],
  "/oraculo/runas/": ["/oraculo/cristais/", "/oraculo/baralho-cigano/", "/jogo-de-tarot/", "/oraculo/tarot-sim-ou-nao/"],
  "/oraculo/cristais/": ["/oraculo/runas/", "/oraculo/baralho-cigano/", "/carta-do-dia/", "/jogo-de-tarot/"],
  "/mapa-astral/": ["/ascendente/", "/signo-chines/", "/astrologia/compatibilidade-amorosa/", "/horoscopo/"],
  "/ascendente/": ["/mapa-astral/", "/horoscopo/", "/signo-chines/", "/astrologia/compatibilidade-amorosa/"],
  "/signo-chines/": ["/mapa-astral/", "/horoscopo/", "/ascendente/", "/numerologia/"],
  "/carta-do-dia/": ["/oraculo/baralho-cigano/", "/oraculo/mesa-real/", "/jogo-de-tarot/", "/horoscopo/"],
  "/numerologia/": ["/mapa-astral/", "/anjo-da-guarda/", "/signo-chines/", "/oraculo/baralho-cigano/"],
  "/anjo-da-guarda/": ["/numerologia/", "/mapa-astral/", "/signo-chines/", "/horoscopo/"],
  "/astrologia/compatibilidade-amorosa/": ["/oraculo/tarot-do-amor/", "/mapa-astral/", "/signo-chines/", "/horoscopo/"],
  "/horoscopo/": ["/mapa-astral/", "/ascendente/", "/carta-do-dia/", "/signo-chines/"],
}

const POPULARES = [
  "/oraculo/baralho-cigano/", "/jogo-de-tarot/", "/mapa-astral/",
  "/oraculo/tarot-sim-ou-nao/", "/signo-chines/", "/oraculo/tarot-do-amor/",
]

/**
 * Bloque "experimente também". `atual` es la ruta de la página, para no
 * ofrecerse a sí misma. `quantos` por defecto 4.
 */
const OutrosJogos = ({ atual, quantos = 4, titulo = "Experimente também" }) => {
  const preferidos = RELACIONADOS[atual] || []
  const ordem = [...preferidos, ...POPULARES, ...JOGOS.map(j => j.url)]
  const vistos = new Set([atual])
  const escolhidos = []
  for (const url of ordem) {
    if (vistos.has(url)) continue
    const j = JOGOS.find(x => x.url === url)
    if (!j) continue
    vistos.add(url)
    escolhidos.push(j)
    if (escolhidos.length === quantos) break
  }
  if (!escolhidos.length) return null
  return (
    <section className="outros-jogos">
      <h2>{titulo}</h2>
      <ul>
        {escolhidos.map(j => (
          <li key={j.url}>
            <Link to={j.url} {...SEM_VIGNETTE}>
              <span className="oj-icone" aria-hidden="true">{j.icone}</span>
              <span className="oj-texto">
                <strong>{j.nome}</strong>
                <span>{j.desc}</span>
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  )
}

export default OutrosJogos
